<mat-vertical-stepper #stepper *ngIf="editable">


    <mat-step *ngIf="isLikeInclinoV3()">
      <ng-template *ngIf="sensorType === DeviceTypes.InclinoV3"  matStepLabel>{{'SELECT_AXIS_INCLINO'|translate}}</ng-template>
      <ng-template *ngIf="sensorType === DeviceTypes.Expe"  matStepLabel>{{'SELECT_CHANNELS_EXPE'|translate}}</ng-template>
      <app-param-axis-inclino *ngIf="sensorType === DeviceTypes.InclinoV3" [deviceParamLirisV3]="deviceParamLirisV3"></app-param-axis-inclino>
      <app-param-channels-expe *ngIf="sensorType === DeviceTypes.Expe" [deviceParamLirisV3]="deviceParamLirisV3"></app-param-channels-expe>
    </mat-step>

    <mat-step>
        <ng-template matStepLabel>{{'OTHER_PARAM'|translate}}</ng-template>
        <app-param-other [deviceParamLirisV3]="deviceParamLirisV3" [sensorType]="sensorType"></app-param-other>
    </mat-step>


    <mat-step>
        <ng-template matStepLabel>{{'PRAMETERS'|translate}} {{'TRIGGER'|translate}} {{'AMPLITUDE'|translate}}, {{deviceParamLirisV3.trigger.amplitude.length}}
            {{'ITEMS'|translate}}
        </ng-template>
        <app-param-trigger-data *ngIf="stepper._getFocusIndex() === getStepperIndex(1)"
                                [deviceParamLirisV3TriggerDataArray]="deviceParamLirisV3.trigger.amplitude"
                                [modeName]="'Amplitude'" [sensorType]="sensorType"
                                [axeInclino]="deviceParamLirisV3.inclinoAxes"></app-param-trigger-data>
    </mat-step>

    <mat-step>
        <ng-template matStepLabel> {{'PRAMETERS'|translate}} {{'TRIGGER'|translate}} {{'MIN'|translate}}, {{deviceParamLirisV3.trigger.threshold.min.length}}
            {{'ITEMS'|translate}}
        </ng-template>
        <app-param-trigger-data *ngIf="stepper._getFocusIndex() === getStepperIndex(2)"
                                [deviceParamLirisV3TriggerDataArray]="deviceParamLirisV3.trigger.threshold.min"
                                [modeName]="'Min'" [sensorType]="sensorType"
                                [axeInclino]="deviceParamLirisV3.inclinoAxes"></app-param-trigger-data>
    </mat-step>

    <mat-step>
        <ng-template matStepLabel>  {{'PRAMETERS'|translate}} {{'TRIGGER'|translate}} {{'MAX'|translate}}, {{deviceParamLirisV3.trigger.threshold.max.length}}
            {{'ITEMS'|translate}}
        </ng-template>
        <app-param-trigger-data *ngIf="stepper._getFocusIndex() === getStepperIndex(3)"
                                [deviceParamLirisV3TriggerDataArray]="deviceParamLirisV3.trigger.threshold.max"
                                [modeName]="'Max'" [sensorType]="sensorType"
                                [axeInclino]="deviceParamLirisV3.inclinoAxes"></app-param-trigger-data>
    </mat-step>


    <mat-step>
        <ng-template matStepLabel> {{'PRAMETERS'|translate}}  {{'FILTER'|translate}} , {{deviceParamLirisV3.trigger.filter.length}}
            {{'ITEMS'|translate}}
        </ng-template>
        <app-param-filter *ngIf="stepper._getFocusIndex() === getStepperIndex(4)"
                          [deviceParamLirisV3FilterArray]="deviceParamLirisV3.trigger.filter"
                          [sensorType]="sensorType"></app-param-filter>
    </mat-step>

    <mat-step *ngIf="sensorType !== DeviceTypes.Liris420V3">
        <ng-template matStepLabel>{{'CALIB_PARAM'|translate}}</ng-template>
        <app-param-calibration [deviceParamLirisV3]="deviceParamLirisV3"
                               [sensorType]="sensorType"></app-param-calibration>
    </mat-step>


</mat-vertical-stepper>

<div *ngIf="!editable">


  <h4 *ngIf="sensorType === DeviceTypes.InclinoV3">{{'SELECT_AXIS_INCLINO'|translate}}</h4>
  <h4 *ngIf="sensorType === DeviceTypes.Expe">{{'SELECT_CHANNELS_EXPE'|translate}}</h4>
    <app-param-axis-inclino *ngIf="sensorType === DeviceTypes.InclinoV3" [deviceParamLirisV3]="deviceParamLirisV3"
                            [editable]="false"></app-param-axis-inclino>
    <app-param-channels-expe *ngIf="sensorType === DeviceTypes.Expe" [deviceParamLirisV3]="deviceParamLirisV3"
                             [editable]="false"></app-param-channels-expe>

    <h4>{{'OTHER_PARAM'|translate}}</h4>
    <app-param-other [deviceParamLirisV3]="deviceParamLirisV3" [editable]="false" [sensorType]="sensorType"></app-param-other>


    <h4>{{'PRAMETERS'|translate}} {{'TRIGGER'|translate}} {{'AMPLITUDE'|translate}}</h4>
    <app-param-trigger-data
            [deviceParamLirisV3TriggerDataArray]="deviceParamLirisV3.trigger.amplitude"
            [modeName]="'Amplitude'" [editable]="false" [sensorType]="sensorType"></app-param-trigger-data>
    <h4> {{'PRAMETERS'|translate}} {{'TRIGGER'|translate}} {{'MIN'|translate}}</h4>
    <app-param-trigger-data
            [deviceParamLirisV3TriggerDataArray]="deviceParamLirisV3.trigger.threshold.min"
            [modeName]="'Min'" [editable]="false" [sensorType]="sensorType"></app-param-trigger-data>
    <h4> {{'PRAMETERS'|translate}} {{'TRIGGER'|translate}} {{'MAX'|translate}}</h4>
    <app-param-trigger-data
            [deviceParamLirisV3TriggerDataArray]="deviceParamLirisV3.trigger.threshold.max"
            [modeName]="'Max'" [editable]="false" [sensorType]="sensorType"></app-param-trigger-data>
    <h4> {{'PRAMETERS'|translate}}  {{'FILTER'|translate}} </h4>
    <app-param-filter
            [deviceParamLirisV3FilterArray]="deviceParamLirisV3.trigger.filter"
            [editable]="false" [sensorType]="sensorType"></app-param-filter>
    <h4 *ngIf="sensorType !== DeviceTypes.Liris420V3">{{'CALIB_PARAM'|translate}}</h4>
    <app-param-calibration  *ngIf="sensorType !== DeviceTypes.Liris420V3" [deviceParamLirisV3]="deviceParamLirisV3" [sensorType]="sensorType"></app-param-calibration>
</div>
<br clear="both"/>
